import {
    ProductVariantBasicInfoContainer,
    ProductVariantImage,
    ProductVariantImageContainer,
    TagLineItem,
    TagLineContainer,
    ProductVariantTitle,
    DimensionText,
    TextLoaderContainer,
    ImageLoaderWrapper,
    DimensionsTable
} from './ProductVariantBasicInfo.styles';
import { ProductVariantSizeDto } from '../types/ProductVariant.types';
import { Context as TranslationContext } from '../shared/contexts/TranslationContext';
import { useContext } from 'react';

export interface ProductVariantBasicInfoProps {
    selectedProductVariantSize: ProductVariantSizeDto | undefined;
    title: string;
    taglines: string[];
    imageUrl: string;
}

export const ProductVariantBasicInfo = ({
    selectedProductVariantSize: selectedAhuSize,
    title,
    taglines,
    imageUrl
}: ProductVariantBasicInfoProps) => {
    const { l } = useContext(TranslationContext);

    return (
        <ProductVariantBasicInfoContainer>
            <TextLoaderContainer>
                <ProductVariantTitle>{title.toUpperCase()}</ProductVariantTitle>
                <TagLineContainer>
                    {taglines.map((tagline, index) => (
                        <TagLineItem key={index}>{tagline}</TagLineItem>
                    ))}
                </TagLineContainer>
            </TextLoaderContainer>

            <ImageLoaderWrapper>
                <ProductVariantImageContainer>
                    <ProductVariantImage src={imageUrl} alt={title} />
                    <DimensionsTable>
                        <tbody>
                            <tr>
                                <td>
                                    <DimensionText>
                                        {l('ahuDesign.Weight')}
                                    </DimensionText>
                                </td>
                                <td>
                                    <DimensionText>
                                        {`${selectedAhuSize?.dimensions.weightDto.weight} ${selectedAhuSize?.dimensions.weightDto.unit}`}
                                    </DimensionText>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <DimensionText>
                                        {l('ahuDesign.length_x')}
                                    </DimensionText>
                                </td>
                                <td>
                                    <DimensionText>
                                        {`${selectedAhuSize?.dimensions.size.length} ${selectedAhuSize?.dimensions.size.unit}`}
                                    </DimensionText>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <DimensionText>
                                        {l('ahuDesign.length_y')}
                                    </DimensionText>
                                </td>
                                <td>
                                    <DimensionText>
                                        {`${selectedAhuSize?.dimensions.size.width} ${selectedAhuSize?.dimensions.size.unit}`}
                                    </DimensionText>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <DimensionText>
                                        {l('ahuDesign.length_z')}
                                    </DimensionText>
                                </td>
                                <td>
                                    <DimensionText>
                                        {`${selectedAhuSize?.dimensions.size.height} ${selectedAhuSize?.dimensions.size.unit}`}
                                    </DimensionText>
                                </td>
                            </tr>
                        </tbody>
                    </DimensionsTable>
                </ProductVariantImageContainer>
            </ImageLoaderWrapper>
        </ProductVariantBasicInfoContainer>
    );
};

export default ProductVariantBasicInfo;
